import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import BuyerDashboard from "@/pages/BuyerDashboard";
import Consultancy from "@/pages/Consultancy";
import PaymentStatus from "@/pages/PaymentStatus";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import useAutoUpdate from "@/lib/useAutoUpdate";

function App() {
  useAutoUpdate();
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<BuyerDashboard />} />
        <Route path="/consultancy" element={<Consultancy />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
